export default "__VITE_ASSET__DuMVfhbe__"